import moment from "moment";
import { getNettoWorkTime } from "./get-netto-work-time";
import { timeDifference } from "./time-difference";

export interface Item {
  startTime: string;
  endTime: string;
  state: "requested" | "approved" | string;
  hours: number;
  workBreakInMinutes: number;
}

export const countHours = (item: Item) => {
  const startTime = moment(item.startTime).toDate();
  const endTime = moment(item.endTime).toDate();
  let nettoWorkTime = 0;
  if (item.state === "requested" || item.state === "approved") {
    nettoWorkTime = getNettoWorkTime(item.hours.toString());
  } else {
    nettoWorkTime =
      timeDifference({ startTime, endTime }) - item.workBreakInMinutes;
  }
  return nettoWorkTime;
};
